import { render, staticRenderFns } from "./HighlightMenuCard.vue?vue&type=template&id=18833ba2&scoped=true&"
import script from "./HighlightMenuCard.vue?vue&type=script&lang=js&"
export * from "./HighlightMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./HighlightMenuCard.vue?vue&type=style&index=0&id=18833ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18833ba2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
